import React, {memo} from 'react';
import {Platform, View} from 'react-native';

import { StyleSheet } from 'react-native';

import {SVGIcon, RNEText, RNEIconButton} from '../../components';
import { width, height, totalSize } from 'react-native-dimension';

interface ConsultationRequestSentModalProps {
  onConfirm?: () => void;
}

function ConsultationRequestSentModal(
  props: ConsultationRequestSentModalProps,
) {

  return (
    <View style={rneStyles.root}>
      <RNEText
        label="Consultation Request Sent!"
        variant="header"
        style={titleFontSize}
        align="center"
        weight="600"
        color="primary"
      />
      <View style={rneStyles.subtitleContainer}>
        <RNEText
          label="We have notified the doctor regarding your request. Once the doctor accepts your request, you can then proceed to pay the consultation fee before it starts."
          variant="subheader"
          style={subtitleFontSize}
          align="center"
          color={Platform.OS === 'web' ? 'blackLight' : 'grey'}
        />
      </View>

      <View style={rneStyles.buttonContainer}>
        <RNEIconButton
          icon={<SVGIcon name="check-white" size={totalSize(5)} />}
          color="secondary"
          size={totalSize(6)}
          onPress={props.onConfirm}
          raised={Platform.OS !== 'web'}
        />
      </View>
    </View>
  );
}

const titleFontSize = {
  fontSize: Platform.OS === 'web' ? 32 : totalSize(1.9),
};

const subtitleFontSize = {
  fontSize: Platform.OS === 'web' ? 24 : totalSize(1.7),
};

const rneStyles = StyleSheet.create(({
  root: {
    padding: height(0),
    margin: height(1),
    marginTop: 0,
    marginBottom: 0,
    height: height(30),
    justifyContent: 'center',
    alignSelf: 'center',
    maxWidth: Platform.OS === 'web' ? 500 : '95%',
  },
  subtitleContainer: {
    marginTop: height(2),
  },
  buttonContainer: {
    marginTop: height(4),
    justifyContent: 'center',
    alignSelf: 'center',
  },
}));

export default memo(ConsultationRequestSentModal);
